import { useState } from "react";
import { GraduationCap, Settings2, CheckCircle2, XCircle } from "lucide-react";
import TargetProdiModal from "@/components/TargetProdiModal";

export const TargetProdiCard = ({ targets = [], utbkBest = null, onChange }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="md:col-span-8 lg:col-span-12 clay-card p-7" data-testid="target-prodi-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 text-sm font-semibold text-[#5C5F5C]"><GraduationCap className="h-4 w-4" /> Target Prodi (UTBK)</div>
        <button onClick={() => setOpen(true)} data-testid="manage-target-btn" className="text-sm px-4 py-2 rounded-full border-2 border-[#1A1C1A] font-medium hover:bg-[#1A1C1A]/5 flex items-center gap-1.5"><Settings2 className="h-4 w-4" /> Kelola Target</button>
      </div>
      {targets.length === 0 ? (
        <p className="text-sm text-[#5C5F5C]">Belum ada target prodi. Pilih maksimal 4 prodi (wajib sebelum TryOut UTBK) untuk melihat status pencapaianmu.</p>
      ) : (
        <>
          <p className="text-xs text-[#5C5F5C] mb-3">Skor UTBK terbaikmu: <b className="text-[#4A6B53]">{utbkBest ?? "—"}</b>. Bandingkan dengan target (<b>estimasi keketatan, bukan kelulusan resmi</b>).</p>
          <div className="grid sm:grid-cols-2 gap-3">
            {targets.map((t, i) => {
              const done = utbkBest != null && utbkBest >= t.target;
              return (
                <div key={i} data-testid={`target-row-${i}`} className={`rounded-xl border p-4 ${done ? "border-[#4A6B53]/40 bg-[#4A6B53]/5" : "border-[#E5E0D8]"}`}>
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0"><p className="text-sm font-semibold text-[#1A1C1A] truncate">{t.prodi}</p><p className="text-xs text-[#5C5F5C] truncate">{t.ptn}</p></div>
                    {utbkBest == null ? <span className="text-xs text-[#5C5F5C] shrink-0">Belum ada TO</span>
                      : done ? <span className="text-xs font-medium text-[#4A6B53] flex items-center gap-1 shrink-0"><CheckCircle2 className="h-4 w-4" /> Tercapai</span>
                      : <span className="text-xs font-medium text-[#D9381E] flex items-center gap-1 shrink-0"><XCircle className="h-4 w-4" /> Belum</span>}
                  </div>
                  <div className="mt-2 h-2 rounded-full bg-[#F0ECE4] overflow-hidden"><div className="h-full rounded-full" style={{ width: `${Math.min(100, utbkBest || 0)}%`, background: done ? "#4A6B53" : "#E25E3E" }} /></div>
                  <p className="text-[11px] text-[#5C5F5C] mt-1">Target estimasi: ±{t.target} (≈{Math.round(200 + (t.target / 100) * 800)} skala UTBK) · skormu: {utbkBest ?? "—"}</p>
                </div>
              );
            })}
          </div>
        </>
      )}
      <TargetProdiModal open={open} onClose={() => setOpen(false)} onSaved={(items) => onChange && onChange(items)} />
    </div>
  );
};

export default TargetProdiCard;
